/**
 * @module experience/shop/shared-browse/components
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
/*tslint:disable:max-file-line-count */

import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Product } from '@support/api/common/product.interface';
import { AddedAccessories } from './models/product-carousel.interface';
import { AccessoriesService } from '@experience/shop/shared-browse/services/accessories-carousel.service';

// Services
import { MatchmediaService } from '@core/public';
import { ProductSelectorService } from '@experience/shop/product-selector/services/product-selector.service';
import { CartSupportService } from '@support/cart-support/services/cart-support.service';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { LoggerService } from '@core/logger/services/logger.service';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';

// Constants
import {
  SHARED_BROWSE_CONSTANTS,
  SHARED_BROWSE_COMPONENTS,
} from '@experience/shop/shared-browse/constants/shared-browse.constants';
import { ACCESSORIES_CAROUSEL_CONSTANTS } from './product-carousel.constants';
import { APIError } from '@support/api/common/error.interface';
import { Cart } from '@support/api/proxies/responses/api-cart-response.interface';
import { HARDGOODS_CONSTANTS } from '@experience/shop/hardgoods/constants/browse-hardgoods.constants';
import { throwError as observableThrowError, Subject } from 'rxjs';
import { takeUntil, catchError } from 'rxjs/operators';
import { BrowseDeviceModel } from '@experience/shop/hardgoods/models/browse-device.model';
@Component({
  selector: 'tmo-product-carousel',
  templateUrl: './product-carousel.component.html',
  styleUrls: ['../../../../../../style-sheets/components/gallery.component.scss'],
})
export class ProductCarouselComponent implements OnInit, OnDestroy {
  // tslint:disable no-any
  public addedAccessories: Object[];

  @Input() public offerId: string;
  /**
   * Default items to display at the same time
   */
  @Input() public isPlanFirst: boolean;

  @Input() public deviceSectionAEMContent: Object;
  /**
   * Default max number of items to display
   */
  @Input() public maxItems: number;
  /**
   * Default items to display at the same time
   */
  @Input() public itemsToDisplay: number;

  /**
   * Data holder
   */
  // @TODO While implementing accessory remove Product[]
  @Input() public productData: any;
  /**
   * Default items to display on mobile
   */
  @Input() public itemsToDisplayOnMobile: number;
  /**
   * Boolean to identify the flow @ToDO Remove this and hanlde trough the parent (PDP)
   */
  @Input() public useRouteParam: boolean;
  /**
   * Boolean to identify the flow (Product Selector)
   */
  @Input() public device: boolean;

  @Input() public isProductSelector: boolean;
  /**
   * Boolean to identify if its device carousel in product selector screen
   */
  @Input() public isDeviceCarouselProductSelector: boolean;

  @Input() public enableArrows: boolean;
  /**
   * Boolean to identify if non-line item
   */
  @Input() public disabledEipPricing: boolean;
  /**
   * Event Handler emiiter
   */
  @Output() public change: EventEmitter<string>;
  /**
   * Element to know the total width of the items : The Strip
   */
  @ViewChild('thumbsStrip', { static: false }) public thumbsStrip: ElementRef;
  /**
   * Element to know the total width of Container to show the Items : The thumbs container
   */
  @ViewChild('thumbsContainer', { static: false }) public thumbsContainer: ElementRef;
  /**
   * Element to know the total width of Container to show the Items : The thumbs container
   */
  @ViewChild('thumbItem', { static: false }) public thumbItem: ElementRef;
  /**
   * variable to show updated browse plan
   */
  // public showUpdatedBrowseDevices: boolean;

  /**
   * Initial variables
   */
  public carouselRIdx: number;
  public stripPosition: number;
  public galleryData: number;
  public leftActive: boolean;
  public rightActive: boolean;
  public isDevice: boolean;
  public activeImage: number;
  public thumbSelected: number;
  public width: string;
  public showSpinner: boolean;
  public accessoriesAlert: boolean;
  public showAccessoryExceedLimitMessage: boolean;
  public productSelectorAddedAccessory: boolean;
  public isAccessoriesCarousel: boolean;
  public deviceConstant: string;
  public isEipEligible: boolean;
  /** Variable to store the constant */
  public nextButton: string;
  public routerURL: string;
  /**
   * Unsubscriber for all subscribtions
   */
  private ngUnsubscribe: Subject<void>;
  constructor(
    public elem: ElementRef,
    public accessoriesService: AccessoriesService,
    private router: Router,
    private matchmediaService: MatchmediaService,
    private stateUtilService: StateStoreUtilsService,
    private cartSupportService: CartSupportService,
    private productSelectorService: ProductSelectorService,
    private objectService: ObjectService,
    private logger: LoggerService
  ) {
    this.ngUnsubscribe = new Subject<void>();
    this.isAccessoriesCarousel = true;
    this.isEipEligible = false;
    this.isPlanFirst = false;
    const twenty = 20;
    this.maxItems = twenty;
    const four = 4;
    this.itemsToDisplay = four;
    this.productData = [];
    const two = 2;
    this.itemsToDisplayOnMobile = two;
    this.useRouteParam = false;
    this.device = false;
    this.isProductSelector = false;
    this.change = new EventEmitter<string>();
    this.stripPosition = 0;
    this.leftActive = false;
    this.rightActive = false;
    this.activeImage = 0;
    this.thumbSelected = this.activeImage + 1;
    this.width = '';
    this.showSpinner = false;
    this.accessoriesAlert = false;
    this.showAccessoryExceedLimitMessage = false;
    this.productSelectorAddedAccessory = false;
    this.nextButton = ACCESSORIES_CAROUSEL_CONSTANTS.NEXTBUTTON;
    this.carouselRIdx = 0;
    this.addedAccessories = [];
    this.isDeviceCarouselProductSelector = false;
    this.enableArrows = false;
    // this.showUpdatedBrowseDevices = SETTINGS.CHANNEL.toLowerCase() === CHANNELS.RETAIL;
  }

  /**
   * Inializes the productData for carosuel componenent.
   * @returns void
   */
  public ngOnInit(): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'entering ngOnInit() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
    this.deviceConstant = ACCESSORIES_CAROUSEL_CONSTANTS.DEVICE;
    this.getData();
    this.accessoriesAlert = this.productSelectorService.getAccessoryCount();
    this.productSelectorAddedAccessory =
      this.productSelectorService.productSelectorAddedAccessory && this.isProductSelector;
    this.contentCheckedAfterLoad();
    if (
      this.stateUtilService.getFamilyId() &&
      this.stateUtilService.getFamilyId() === ACCESSORIES_CAROUSEL_CONSTANTS.MOBILE_INTERNET
    ) {
      this.routerURL = HARDGOODS_CONSTANTS.BROWSE_TABLETS;
    } else {
      this.routerURL = HARDGOODS_CONSTANTS.BROWSE_DEVICES;
    }
    this.productSelectorService.changeRouteSelection$.subscribe((changeRouteSelection: string) => {
      if (
        changeRouteSelection &&
        changeRouteSelection === ACCESSORIES_CAROUSEL_CONSTANTS.MOBILE_INTERNET
      ) {
        this.routerURL = HARDGOODS_CONSTANTS.BROWSE_TABLETS;
      } else {
        this.routerURL = HARDGOODS_CONSTANTS.BROWSE_DEVICES;
      }
    });
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      ' Exiting ngOnInit() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /** Change Carousel Limit call setMaxItems nad moveStrip method
   * @returns void
   */
  public changeCarouselLimit(): void {
    this.contentCheckedAfterLoad();
    if (this.enableArrows) {
      this.setMaxItems();
      this.moveStrip();
    }
  }

  /**
   * Enable or dissable arrows
   * @returns void
   */
  public checkArrows(): void {
    this.leftActive = this.stripPosition < 0;
    this.rightActive = this.stripPosition > this.itemsToDisplay - this.galleryData;
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      ' Exiting checkArrows() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Save state of the strip on right arrow click
   * @returns void
   */
  public moveRight(): void {
    if (this.rightActive) {
      this.carouselRIdx++;
      this.stripPosition--;
      this.moveStrip();
    }
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'Exiting moveRight() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Save state of the strip on left arrow click
   * @returns void
   */
  public moveLeft(): void {
    if (this.leftActive) {
      this.carouselRIdx--;
      this.stripPosition++;
      this.moveStrip();
    }
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      ' Exiting moveLeft() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Check if Eip is eligible or not
   * @returns void
   */
  public checkEipEligibility(isEipEligible: boolean): void {
    this.isEipEligible = isEipEligible;
  }

  /**
   * Do the calclulation about how much move tehe strip
   * @returns void
   */
  public moveStrip(): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'Entering moveStrip() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
    this.checkArrows();
    if (this.thumbsStrip && this.thumbsContainer) {
      this.thumbsStrip.nativeElement.style.left = Math.round(
        this.stripPosition * (this.thumbsContainer.nativeElement.clientWidth / this.itemsToDisplay)
      )
        .toString()
        .concat('px');
      this.checkArrows();
    }
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'Exiting moveStrip() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Check when native elements are loaded
   * @returns void
   */
  public contentCheckedAfterLoad(): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'entering contentCheckedAfterLoad() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
    if (this.thumbsContainer && this.thumbItem) {
      this.width = (this.thumbsContainer.nativeElement.clientWidth / this.itemsToDisplay)
        .toString()
        .concat('px');
    }
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'exiting contentCheckedAfterLoad() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Destroys all the subscriptions
   * @returns void
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'entering ngOnDestroy() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Calls productData if the parent dosnt provide the same.
   * @returns void
   */
  public getData(): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'entering getData() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
    if (this.useRouteParam) {
      const offerId = this.stateUtilService.getSelectedOfferId();
      const deviceDetails = this.stateUtilService.getSelectedDeviceDetails(offerId);
      const productDetails = deviceDetails.getProductDetails();
      this.offerId = productDetails && productDetails.offerId ? productDetails.offerId : '';
      this.isDevice =
        productDetails && productDetails.type === ACCESSORIES_CAROUSEL_CONSTANTS.DEVICE
          ? true
          : false;
      // TODO: Removed relationship call will be use in future sprint
      // this.accessoriesService.getAccessories(this.offerId, ASSISTED_API_MAP.API_2110_getCompatibleAccessories)
      //   .subscribe((response: Accessories) => {
      //     this.logger.debug(SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE, SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      //       'get accessories in getData() responded with:  ' + JSON.stringify(response));
      //     if (response.products) {

      //       for (let i = 0; i < response.products.length; i++) {
      //         this.productData.push(response.products[i]);
      //       }
      //       this.setMaxItems();
      //       this.moveStrip();
      //     }
      //   }, (err: APIError) => {
      //     this.logger.error(SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE, SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      //       'get accessories in getData() failed with:  ' + JSON.stringify(err));
      //     return observableThrowError(err);
      //   });
    } else if (this.productData.length > 0) {
      this.setMaxItems();
      this.moveStrip();
    }
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'exiting getData() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Sets the maximum number of items to scroll
   * @returns void
   */
  public setMaxItems(): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'entering setMaxItems() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
    this.galleryData = this.productData.length;
    if (this.matchmediaService.isPhone()) {
      this.itemsToDisplay = this.itemsToDisplayOnMobile;
    }
    if (this.maxItems && this.galleryData > this.maxItems) {
      this.productData.splice(-1 * (this.galleryData - this.maxItems));
      this.galleryData = this.maxItems;
    } else if (this.galleryData < this.itemsToDisplay) {
      this.itemsToDisplay = 1;
    }
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'exiting setMaxItems() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Handle the click event
   * @returns void
   */
  public handleClick(item: BrowseDeviceModel): void {
    // if (this.showUpdatedBrowseDevices) {
    //   this.stateUtilService.setProductDetails(item.product, item.offerId);
    //   this.stateUtilService.setOfferId(item.offerId);
    //   if (item.productType.toUpperCase() === HARDGOODS_CONSTANTS.DEVICE) {
    //     this.router.navigate([HARDGOODS_CONSTANTS.BROWSE_DEVICES_URL], { queryParams: { globalSearch: true, allowEdit: true } });
    //   }
    //   else {
    //     this.router.navigate([HARDGOODS_CONSTANTS.BROWSE_TABLET_URL], { queryParams: { globalSearch: true, allowEdit: true } });
    //   }
    // }
    // else {
    this.stateUtilService.setProductDetails(item.product);
    if (this.objectService.get(item, 'colorOptions.0.name')) {
      this.router.navigate(
        [HARDGOODS_CONSTANTS.PRODUCT_DETAILS, item.canonicalUrl, item.colorOptions[0].name],
        { queryParams: { allowEdit: true } }
      );
    } else {
      this.router.navigate([HARDGOODS_CONSTANTS.PRODUCT_DETAILS, item.canonicalUrl], {
        queryParams: { allowEdit: true },
      });
    }
    // }
  }

  /**
   * Handle the click event to to accessories route
   * @returns void
   */
  public goToAccessories(path: string): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'entering goToAccessories() in ' +
        SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL +
        '. Input path:' +
        path
    );
    this.router.navigate([path]);
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'exiting goToAccessories() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Handle the click event for device selection
   * @param device offerId
   */
  public navigateToDevicePdp(deviceOfferId: string): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'entering navigateToDevicePdp() in ' +
        SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL +
        '. Input deviceOfferId :' +
        deviceOfferId
    );
    this.router.navigate(['/product-details', { device: deviceOfferId }]);
  }

  /**
   * Selection of Accessory Checkbox
   * @param accessory : selected accessory
   * @param event : selection of checkbox
   * @returns void
   */
  public onAccessoryCheckBoxClick(accessory: Product, event: Event): void {
    accessory.isSelected = !accessory.isSelected;
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      `entering onAccessoryCheckBoxClick() in ${SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL}`,
      `. Input accessory: ${accessory}`,
      `and event: ${event}`
    );
    event.stopPropagation();
    const accessoryCount: number = this.productSelectorService.getExistingAccessoryCount(
      accessory.defaultSku
    );
    this.showAccessoryExceedLimitMessage = false;
    const maxAccessoryLimit = 5;
    if (accessoryCount === maxAccessoryLimit) {
      accessory.isSelected = !accessory.isSelected;
      this.showAccessoryExceedLimitMessage = !accessory.isSelected;
    } else if (accessoryCount > 0) {
      this.showSpinner = true;
      const accessoryQuantity = accessory.isSelected ? accessoryCount + 1 : accessoryCount - 1;
      if (accessoryQuantity === 0) {
        this.removeAccessory(accessory.defaultSku);
      } else {
        this.updateAccessoryToExistingSku(accessory, accessoryQuantity);
      }
    } else {
      this.showSpinner = true;
      this.addAccessory(accessory.defaultSku, accessory.familyCode, 1);
    }
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'exiting onAccessoryCheckBoxClick() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Removing selected acceory
   * @param accessorySku : accessory sku details
   * @returns void
   */
  public removeAccessory(accessorySku: string): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'entering removeAccessory() in ' +
        SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL +
        '. Input accessorySku: ' +
        accessorySku
    );
    this.cartSupportService
      .removeAccessory(accessorySku)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (cartResponse: Cart) => {
          this.logger.debug(
            SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
            SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
            'removeAccessory() in ' +
              SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL +
              'was successful with: ' +
              JSON.stringify(cartResponse)
          );
          this.showSpinner = false;
          const tileId = this.stateUtilService.getTileIdInFocus();
          this.addedAccessories = this.stateUtilService.getAccessories();
          this.addedAccessories.forEach((getAddedAccessories: AddedAccessories) => {
            if (getAddedAccessories.tileId === tileId && getAddedAccessories.sku === accessorySku) {
              this.addedAccessories.splice(this.addedAccessories.indexOf(getAddedAccessories), 1);
            }
          });
          this.stateUtilService.setAccessories(this.addedAccessories);
        },
        (err: APIError) => {
          this.logger.error(
            SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
            SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
            'removeAccessory() failed with:  ' + JSON.stringify(err)
          );
          return observableThrowError(err);
        }
      );
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'exiting removeAccessory() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Updating Accessory to existing sku
   *
   * @private
   * @param {Product} accessory
   * @param {number} selectedQty
   * @memberof ProductCarouselComponent
   */
  public updateAccessoryToExistingSku(accessory: Product, selectedQty: number): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      `entering updateAccessoryToExistingSku() in ${SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL}`,
      `Inputs accessory: ${JSON.stringify(accessory)}`,
      `, selectedQty: ${selectedQty}`
    );
    this.cartSupportService
      .updateAccessory(accessory, selectedQty)
      .pipe(
        catchError((err: APIError) => {
          this.logger.error(
            SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
            SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
            'updateAccessory()failed with:  ' + JSON.stringify(err)
          );
          return observableThrowError(err);
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((cartResponse: Cart) => {
        this.logger.debug(
          SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
          SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
          'updateAccessory() in ' +
            SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL +
            'was successful with: ' +
            JSON.stringify(cartResponse)
        );
        this.showSpinner = false;
        this.productSelectorService.productSelectorAddedAccessory = true;
        const accessorySelection = this.createAddedAccessoryStructure(accessory.defaultSku);
        this.addedAccessories.push(accessorySelection);
        this.stateUtilService.setAccessories(this.addedAccessories);
      });
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'exiting updateAccessoryToExistingSku() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Adding Accessory to existing sku
   * @param sku : details of accessories
   * @param offerId : offer Id
   * @param selectedQty : quantity of selected accessory
   * @returns void
   */
  private addAccessory(sku: string, offerId: string, selectedQty: number): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      `entering addAccessory() in ${SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL}`,
      `Inputs sku: ${sku} offerId: ${offerId}`,
      `selectedQty: ${selectedQty}`
    );
    this.cartSupportService
      .addToCart(sku, offerId, selectedQty)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (cartResponse: Cart) => {
          this.logger.debug(
            SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
            SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
            'addToCart() in ' +
              SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL +
              'was successful with: ' +
              JSON.stringify(cartResponse)
          );
          this.showSpinner = false;
          this.productSelectorService.productSelectorAddedAccessory = true;
          const accessorySelection = this.createAddedAccessoryStructure(sku);
          this.addedAccessories.push(accessorySelection);
          this.stateUtilService.setAccessories(this.addedAccessories);
        },
        (err: APIError) => {
          this.logger.error(
            SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
            SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
            'addToCart() failed with:  ' + JSON.stringify(err)
          );
          return observableThrowError(err);
        }
      );
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'exiting addAccessory() in ' + SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL
    );
  }

  /**
   * Used to create accessory structure.
   * @param sku : details of accessories
   * @returns AddedAccessories
   */
  private createAddedAccessoryStructure(sku: string): AddedAccessories {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL,
      'entering createAddedAccessoryStructure() in ' +
        SHARED_BROWSE_COMPONENTS.PRODUCT_CAROUSEL +
        'Inputs sku: ' +
        sku
    );
    const accessorySelection = {
      tileId: this.stateUtilService.getTileIdInFocus(),
      sku: sku,
    };
    return accessorySelection;
  }
}
